import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Eye, EyeOff } from 'lucide-react';

export default function AccessibilityToggle() {
  const [isHighContrast, setIsHighContrast] = useState(false);

  useEffect(() => {
    // Check if user previously enabled high contrast
    const savedSetting = localStorage.getItem('high-contrast-enabled');
    if (savedSetting === 'true') {
      setIsHighContrast(true);
      document.documentElement.classList.add('high-contrast');
    }
  }, []);

  const toggleHighContrast = () => {
    setIsHighContrast((prev) => {
      const newValue = !prev;
      if (newValue) {
        document.documentElement.classList.add('high-contrast');
        localStorage.setItem('high-contrast-enabled', 'true');
      } else {
        document.documentElement.classList.remove('high-contrast');
        localStorage.setItem('high-contrast-enabled', 'false');
      }
      return newValue;
    });
  };

  return (
    <motion.button
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={toggleHighContrast}
      className={`fixed top-24 lg:top-32 right-0 z-[80] p-3 rounded-l-lg shadow-lg border border-r-0 transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 ${
        isHighContrast 
          ? 'bg-black text-white border-white focus:ring-black' 
          : 'bg-ink text-white border-ink hover:bg-rule-3 focus:ring-rule-3 hover:border-rule-3'
      }`}
      aria-label={isHighContrast ? "Disable High Contrast" : "Enable High Contrast"}
      title={isHighContrast ? "Disable High Contrast" : "Enable High Contrast"}
    >
      {isHighContrast ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
    </motion.button>
  );
}
